import React from 'react';
import { motion } from 'framer-motion';
interface GlowOrbProps {
  color?: 'primary' | 'gold' | 'blue';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  position?: string;
  delay?: number;
}
export function GlowOrb({
  color = 'primary',
  size = 'lg',
  position = 'top-0 left-0',
  delay = 0
}: GlowOrbProps) {
  const colors = {
    primary: 'from-primary-glow/30 to-transparent',
    gold: 'from-gold/20 to-transparent',
    blue: 'from-blue-500/20 to-transparent'
  };
  const sizes = {
    sm: 'w-64 h-64',
    md: 'w-96 h-96',
    lg: 'w-[600px] h-[600px]',
    xl: 'w-[800px] h-[800px]'
  };
  return <motion.div animate={{
    scale: [1, 1.1, 1],
    opacity: [0.5, 0.8, 0.5]
  }} transition={{
    duration: 8,
    repeat: Infinity,
    ease: 'easeInOut',
    delay: delay
  }} className={`absolute rounded-full blur-3xl bg-radial-gradient pointer-events-none -z-10 ${colors[color]} ${sizes[size]} ${position}`} style={{
    background: `radial-gradient(circle, var(--tw-gradient-from) 0%, var(--tw-gradient-to) 70%)`
  }} data-id="element-129" />;
}